export default "__VITE_ASSET__CAY4dqdf__"